// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  fetchRadioArchitectures,
  fetchRadioAtpcTypes,
  fetchRadioCompanies,
  fetchRadioCurveTypeCodes,
  fetchRadioDuplexModes,
  fetchRadioModulationSchemes,
  fetchRadioModulationTypes,
  fetchRadioPowerTypes,
  fetchRadioRadioTypes,
  fetchRadioStabilities,
  fetchRadioStatuses,
} from 'helpers/api'

import sortByCompanyName from '../helpers/sortByCompanyName'
import { settingsFailedToLoadMessage } from 'redux/modules/notifications/helpers'
import { scrubAllModulationSchemes } from './helpers'

import {
  addRadioSettings,
  catchEmptySettings,
} from 'redux/modules/domain'

const fetchAndAddRadioSettings = () => async (dispatch, getState) => {
  const settings = [
    fetchRadioArchitectures(),
    fetchRadioAtpcTypes(),
    fetchRadioCompanies(),
    fetchRadioCurveTypeCodes(),
    fetchRadioDuplexModes(),
    fetchRadioModulationSchemes(),
    fetchRadioModulationTypes(),
    fetchRadioPowerTypes(),
    fetchRadioRadioTypes(),
    fetchRadioStabilities(),
    fetchRadioStatuses(),
  ]

  let r

  try {
    r = await Promise.all(settings)
  } catch (err) {
    console.warn(err)
    dispatch(settingsFailedToLoadMessage('Radio', err))
    return false
  }

  const architectures = r[0].entities
  const atpcTypes = r[1].entities
  const companies = sortByCompanyName(r[2].entities)
  const curveTypeCodes = r[3].entities
  const duplexModes = r[4].entities
  const modulationSchemes = scrubAllModulationSchemes(r[5].entities)
  const modulationTypes = r[6].entities
  const powerTypes = r[7].entities
  const radioTypes = r[8].entities
  const stabilities = r[9].entities
  const statuses = r[10].entities

  // NOTE: null option is the last option in the UI. This breaks the convention of
  // placing the null value first in dynamically generated input values (think RadioSetFromState, SelectFromState etc)
  // since using CSS to manipulate the order of the radio buttons would break other CSS and get real messy,
  // instead just add the null option to the end of the list and tell the input group to not create a null option.
  atpcTypes.push({ atpcType: 'N/A', atpcTypeId: '' })

  const radioSettings = {
    architectures,
    atpcTypes,
    companies,
    curveTypeCodes,
    duplexModes,
    modulationSchemes,
    modulationTypes,
    powerTypes,
    radioTypes,
    stabilities,
    statuses,
  }

  dispatch(catchEmptySettings('Radio', radioSettings))
  dispatch(addRadioSettings(radioSettings))
  return radioSettings
}

export default fetchAndAddRadioSettings
